module.exports = __webpack_public_path__ + "static/icon-27c768d88ff1f3e06810306d40b9bc22.png";